<template>
  <div class="float-right">
    <b-modal
        ref="show-status-media-import"
        :title="$t('modal.title.add_new_import')"
        ok-title="Save"
        cancel-title="Cancel"
        size="md">
      <template #modal-header>
        <div class="w-100">
          <h4 class="float-left">{{ $t('modal.title.question_upload_multimedia') }}</h4>
        </div>
      </template>
      <div class="create-question">
        <b-spinner v-if="showSpinner" class="align-middle"></b-spinner>
        Upload multimedia status: {{ status }}
      </div>
      <template #modal-footer>
        <div class="w-100">
          <div class="buttons float-right">
            <b-button type="button" variant="primary" class="mr-2"  @click="hideModal">{{$t('btn.close')}}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>

//TODO: import / load / get locale the right way
import axios from "axios";
import alertify from "alertifyjs";

let locale = locale ? locale : "en";

export default {
  data() {
    return {
      apiKey: null,
      status: 'WAITING',
      importMediaStatusInterval: null,
      requestInProgress: false
    };
  },
  mounted() {
    this.setImportMediaStatusInterval();
  },
  computed: {
    showSpinner() {
      return this.status !== 'IMPORTED';
    }
  },
  methods: {
    openModal() {
      this.$refs['show-status-media-import'].show()
    },
    hideModal() {
      this.clearImportMediaStatusInterval();

      // if(this.status === 'IMPORTED') {
        this.$parent.getStatuses();
        this.$parent.$emit('refreshGrid');
      // }

      this.$refs['show-status-media-import'].hide();
    },
    checkImportStatus() {
      if(!this.requestInProgress) {
        this.requestInProgress = true;

        axios.get(`/api/question/import/${this.importMultimediaId}`)
          .then((response) => {
            this.requestInProgress = false;
            this.status = response.data.status;

            if(this.status === 'IMPORTED') {
              this.clearImportMediaStatusInterval();
            }
          })
          .catch((error) => {
            alertify.error('Something went wrong');
            console.log(error);
          });
      }
    },
    setImportMediaStatusInterval() {
      this.importMediaStatusInterval = setInterval(() => {
        this.checkImportStatus();
      }, 1000);
    },
    clearImportMediaStatusInterval() {
      clearInterval(this.importMediaStatusInterval);
    },
  }
}
</script>
